import { Organization } from "@/types/organization";
import { Card, CardFooter, CardHeader, Chip } from "@heroui/react";
import { formatGroupType } from "@/components/network/networkUtils";

type MobileOrganizationCardProps = {
    organization: Organization;
    onPress?: () => void;
};

export default function MobileOrganizationCard({
    organization,
    onPress,
}: MobileOrganizationCardProps) {
    const serviceProviderName = organization.service_provider?.name;

    return (
        <Card
            isPressable={!!onPress}
            onPress={onPress}
            className="w-full hover:bg-gray-200"
            shadow="sm"
        >
            <CardHeader className="pb-1 px-3">
                <div className="flex w-full items-start justify-between gap-2 text-left">
                    <div className="flex flex-1 flex-col items-start min-w-0 text-left">
                        <p className="w-full text-left font-semibold text-lg truncate">
                            {organization.name}
                        </p>
                    </div>

                    <Chip
                        size="sm"
                        radius="sm"
                        variant="flat"
                        color={
                            organization.group_type === "service provider"
                                ? "primary"
                                : "secondary"
                        }
                        className="shrink-0"
                    >
                        {formatGroupType(organization.group_type)}
                    </Chip>
                </div>
            </CardHeader>

            <CardFooter className="text-xs pt-0 px-3 justify-start">
                <div className="w-full text-left truncate text-gray-600">
                    {serviceProviderName
                        ? `Service Provider: ${serviceProviderName}`
                        : "--"}
                </div>
            </CardFooter>
        </Card>
    );
}